module.exports = __webpack_public_path__ + "assets/images/district-icon.b34db26df0042b60d2d4a49455038fe2.svg";